/*
 * @Author: JamesWong
 * @Description: 支付配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-08 14:15:38
 */
export default {
  channelPaymentMethods: '渠道支付方式',
  set: '設置',
  setPaymentMethods: '設置支付方式',
  confirm: '確定',
  cancel: '取消',
  channel: '渠道',
  order: '序號',
  channelNumber: '渠道編號',
  account: '戶口',
  accountFilter: '戶口篩選',
  weChatScanPayment: '微信掃碼付',
  paymentSetTips: '提示：同時編輯多個渠道時，支付方式需要重新選擇，不選擇將被置為空',
  pleaseSelectAgain: '請重新選擇',
  selectPaymentMethod: '選擇支付方式',
  paymentNumber: '支付編號',
  merchantID: '商戶ID',
  submerchantID: '子商戶ID',
  Note: '備註',
  appId: '商戶ID',
  token: '授權Token',
  tokenTime: '授權時間',
  wechatFaceIDPay: '微信刷臉支付',
  wechatClientSelfpay: '微信客戶自付',
  alipayScancodePay: '支付寶掃碼付',
  alipayNumber: '支付寶編號',
  systemBusinessNumber: '系統商編號',
  enterChannelTips: '請輸入渠道編號、名稱搜索',
  channelName: '渠道名稱',
  wechatPaymentDisposition: '微信支付配置',
  wechatPaymentTips: '微信支付支援三種支付類型：',
  wechatPaymentTips1: '1.掃碼支付：收銀員掃客戶的付款碼，適用於POS收銀；',
  wechatPaymentTips2: '2.客戶在特定自助機器上，自主完成刷臉支付，適用于自主購物機；',
  wechatPaymentTips3: '3.客戶自支付：客戶在個人手機中點擊付款，調用微信支付，適用于微商城、掃碼購程式；',
  wechatPaymentTipsPlus: '注意：三種類型只能各自默認一個支付，渠道沒有單獨配置支付方式時，將自動使用預設的支付方式。',
  Mode: '模式',
  type: '類型',
  defaultTips: '是否默認',
  default: '默認',
  operate: '備註',
  detail: '詳情',
  paymentMethodDetail: '支付方式詳情',
  paymentType: '支付類型',
  APPKEY: 'APPKEY',
  certification: '證書',
  certificationDocument: '證書文件',
  certificationPassword: '證書密碼',
  alipayPaymentDisposition: '支付寶支付配置',
  status: '狀態',
  authorizedMerchantID: '授權商戶ID',
  authorized: '已授權',
  authorize: '授權',
  unAuthorized: '未授權',
  privateKey: '私密金鑰',
  publicKey: '公開金鑰',
  signatureType: '簽名類型',
  selectedTips: '請先選擇渠道再設置支付方式',
  success: '成功',
  configuredChannel: '已配置渠道',
  reauthorize: '重新授權'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-hant/payment.js